import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div className='header'>
      <div className="header-container">
      <h2> Order your favourite food here </h2>
      <p>he app becomes a convenient one-stop-shop for users, allowing them to order all sorts of items, food or otherwise</p>
      <button>View Menu</button>
      </div>
    </div>
  )
}

export default Header
